<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M17 9.6c0 3.4-3.1 6.1-7 6.1-.8 0-1.6-.1-2.3-.3L3.5 17l1.1-3.1C3.6 12.7 3 11.2 3 9.6 3 6.2 6.1 3.5 10 3.5s7 2.7 7 6.1z"/><path d="M7.2 9.6h.01M10 9.6h.01M12.8 9.6h.01"/></svg>
</template>
